.ux-icon-library {
  display: block;

  &__intro-container {
    margin: 0 15px;
  }

  &__search-container {
    margin: 25px 15px 0;
    margin-top: 25px;
    max-width: 800px;
  }

  &__filter-container {
    margin-top: 25px;
  }

  &__tags-container {
    display: flex;
    flex-wrap: nowrap;
    height: 45px;
    -ms-overflow-style: none;
    overflow-x: scroll;
    padding: 10px 15px 5px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .ux-tag {
      cursor: pointer;
      margin-bottom: 0;
      white-space: nowrap;
    }
  }

  &__filter {
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (width >= 1024px) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &__filter .ux-dropdown {
    width: 100%;

    @media (width >= 1024px) {
      width: calc(33% - 15px);
    }
  }

  &__results-details {
    font-size: $size-text-normal-plus;
    margin: 10px 15px 0;
  }

  &__loading-container {
    margin: 25px 15px 0;
  }

  &__results-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 20px;
  }
}

.ux-icon-library-thumbnail {
  box-shadow: 0;
  cursor: pointer;
  height: 205px;
  margin: 0 10px 25px;
  overflow: hidden;
  padding: 20px;
  position: relative;
  transition: box-shadow $animationSpeed-fast $animationEasing-ease;
  width: calc(50% - 10px);

  &:hover,
  &--is-selected {
    box-shadow: 0 7px 22px rgb(19 19 19 / 10%);
  }

  &__action-buttons {
    display: flex;
    opacity: 0;
    position: absolute;
    right: 15px;
    top: -30px;
    transition: all $animationSpeed-fast $animationEasing-ease;
  }

  &__container {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 115px;
    justify-content: center;
    margin-top: 30px;
    padding-bottom: 35px;
    pointer-events: none;
    position: relative;
    transition: all $animationSpeed-fast $animationEasing-ease;
    width: 100%;
  }

  &__container ux-icon {
    font-size: 70px;
  }

  &__container ux-icon {
    font-size: 70px;
    left: 50%;
    position: absolute;
    top: 0;
    transform: translate(-50%);
    transition: all $animationSpeed-fast $animationEasing-ease;
  }

  &__name {
    @include font(bold);

    bottom: 0;
    left: 50%;
    position: absolute;
    transform: translate(-50%);
    transition: all $animationSpeed-fast $animationEasing-ease;
    white-space: nowrap;
  }

  &__weight {
    @include font(light);

    bottom: -22px;
    color: $color-gray-text;
    display: block;
    left: 50%;
    position: absolute;
    text-align: center;
    transform: translate(-50%);
    transition: all $animationSpeed-fast $animationEasing-ease;
  }

  &__description {
    opacity: 0;
    position: absolute;
    top: 200px;
    transition: all $animationSpeed-fast $animationEasing-ease;
    width: calc(100% - 40px);
  }

  &:hover &__description,
  .selected &__description {
    opacity: 1;
    top: 110px;
  }

  &:hover &__container,
  .selected &__container {
    height: 85px;
    margin-top: 60px;
    padding-bottom: 20px;
    width: 60%;
  }

  &:hover &__container ux-icon,
  .selected &__container ux-icon {
    font-size: 50px;
    left: 0;
    transform: translate(0);
  }

  &:hover &__name,
  .selected &__name {
    left: 0;
    transform: translate(0);
  }

  &:hover &__weight,
  .selected &__weight {
    left: 0;
    transform: translate(0);
  }

  &:hover &__action-buttons,
  .selected &__action-buttons {
    opacity: 1;
    top: 20px;
  }

  @media (width >= 568px) {
    width: calc(33.33% - 10px);
  }

  @media (width >= 768px) {
    width: calc(25% - 10px);
  }

  @media (width >= 1024px) {
    width: calc(20% - 20px);
  }

  @media (width >= 1600px) {
    width: calc(15.5% - 10px);
  }
}
